<template>
  <div class="page flex-col">
    <HeadVue></HeadVue>
    <section class="banner" style="margin-top: 60px">
      <div class="banner-cotent">
      </div>

    </section>
    <div class="group_1" style="overflow-y: hidden;overflow-x: hidden">
      <div class="box_17 flex-col">

        <div style="overflow-y: hidden">
          <div class="block_10 flex-row">
            <div v-for="(item, index) in menuItems" :key="index"
                 :class="['text-wrapper_' + (index + 2), 'flex-col', 'menu-item', { active: changeBtn === index }]"
                 @click="handleMenuClick(index)">
              <span :class="['text_' + (index + 5)]">{{ item.name }}</span>
            </div>
          </div>
          <div v-if="changeBtn == 0">
            <yanjiuyuan style="padding-bottom: 50px"></yanjiuyuan>
          </div>
          <div v-else-if="changeBtn == 1">
            <hzshengtai style="padding-bottom: 50px"></hzshengtai>
          </div>
          <div v-else-if="changeBtn == 2">
            <yjshijiao style="padding-bottom: 50px"></yjshijiao>
          </div>
          <div v-else-if="changeBtn == 3">
            <Journal style="padding-bottom: 100px"></Journal>
          </div>
        </div>

      </div>
    </div>
    <FooterVue style="margin-bottom: 0;margin-top: 0"></FooterVue>
  </div>
</template>
<script>
import HeadVue from "../../common/HeadVue.vue";
import FooterVue from "../../common/FooterVue.vue";
// import Academy from "../Academy/index.vue";
import yanjiuyuan from "../yanjiuyuan/index.vue";
import hzshengtai from "../hzshengtai/index.vue";
import yjshijiao from "../yjshijiao/index.vue";
// import CooperativeEcology from "../CooperativeEcology/index.vue";
import Journal from "../Journal/index.vue";
// import ResearchLayout from "../ResearchLayout/index.vue";
export default {
  // eslint-disable-next-line vue/multi-word-component-names
  name:'index',
  components: {
    HeadVue,
    FooterVue,
    // Academy,
    // CooperativeEcology,
    Journal,
    // ResearchLayout,
    hzshengtai,
    yanjiuyuan,
    yjshijiao,
  },
  metaInfo: {
    title: '滁州人工智能-明晟智能科技有限公司',
    meta: [
      { name: 'description', content: '明晟智能科技有限公司是专注于垂直领域大语言模型技术创新的领军企业，致力于将智能科技深度融入高等教育、政务管理、医疗健康及新能源等多元领域' },
      { property: 'og:type', content: 'webpage' },
      { property: 'og:title', content: '滁州人工智能-明晟智能科技有限公司' },
      { property: 'og:description', content: '明晟智能科技有限公司是专注于垂直领域大语言模型技术创新的领军企业，致力于将智能科技深度融入高等教育、政务管理、医疗健康及新能源等多元领域' },
      { property: 'og:url', content: 'https://minsun-ai.com/' },
      { name: 'Keywords',content: "明晟智能科技有限公司,明晟,明晟智能,滁州人工智能,人工智能,AI,明晟大模型,明晟工业大模型"}
    ]
  },
  data() {
    return {
      changeBtn: 0,
      menuItems: [
        { name: '研究院' },
        { name: '合作生态' },
        { name: '研究布局' },
        { name: '期刊' }
      ],
    };
  },
  mounted() {
    this.scrollToBottom()
  },
  methods: {
    handleMenuClick(index) {
      this.changeBtn = index;
    },
    scrollToBottom() {
      this.$nextTick(() => {
        if (this.$refs.container) {
          this.$refs.container.scrollTop = 0;
        }
      });

    },
  },
};
</script>
<style scoped lang="css" src="./assets/index.css" />
<style scoped>
/* 添加在文件末尾，在 src="./assets/index.css" 之后 */
.active {
  background-color: rgba(7, 103, 252, 1) !important;
}

.active span {
  color: #ffffff !important;
}
.selectResearch {
  height: 1797px !important;
}
.banner-cotent {
  height: 500px;
  //width: 100vw;
  background-repeat: no-repeat;
  background-position: center;
  background-size: 100% 100% ;
  //text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  background-image:  url("./assets/img/banner.png");
}

.title{
  background-image: linear-gradient(45deg, rgba(7, 103, 252, 1) 0, rgba(22, 237, 140, 1) 100%);
  //width: 205px;
  height: 56px;
  overflow-wrap: break-word;
  font-size: 50px;
  font-family: Alimama ShuHeiTi-Bold;
  font-weight: 700;
  text-align: left;
  white-space: nowrap;
  line-height: 56px;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  margin-bottom: 20px;
}
</style>
